import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./CookieBanner.css";

const CONSENT_KEY = "gofoton_cookie_consent";
const CONSENT_VERSION = 1;
const CONSENT_DURATION = 180 * 24 * 60 * 60 * 1000;

export const getCookieConsent = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (!saved || saved.version !== CONSENT_VERSION || !saved.savedAt) return null;
    if (Date.now() - saved.savedAt > CONSENT_DURATION) {
      localStorage.removeItem(CONSENT_KEY);
      return null;
    }
    return saved;
  } catch {
    return null;
  }
};

export const hasAnalyticsConsent = () => getCookieConsent()?.analytics === true;

export const openCookieSettings = () => {
  window.dispatchEvent(new Event("gofoton-open-cookie-settings"));
};

function CookieBanner() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getCookieConsent());

    const openSettings = () => setVisible(true);
    window.addEventListener("gofoton-open-cookie-settings", openSettings);
    return () => window.removeEventListener("gofoton-open-cookie-settings", openSettings);
  }, []);

  const saveConsent = (analytics) => {
    const consent = { necessary: true, analytics, version: CONSENT_VERSION, savedAt: Date.now() };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    window.dispatchEvent(new CustomEvent("gofoton-cookie-consent-changed", { detail: consent }));
    setVisible(false);
  };

  const excluded = location.pathname.startsWith("/admin") || location.pathname.startsWith("/login") || location.pathname.startsWith("/portal");
  if (!visible || excluded) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-text">
        <strong>Your privacy matters.</strong>
        <span>We use necessary cookies to keep the site working and optional analytics cookies to understand how visitors use Go!Foton. <Link to="/privacy-policy">Privacy Policy</Link></span>
      </div>
      <div className="cookie-banner-actions">
        <button type="button" className="cookie-button" onClick={() => saveConsent(false)}>Reject Non-Essential</button>
        <button type="button" className="cookie-button" onClick={() => saveConsent(true)}>Accept All</button>
      </div>
    </div>
  );
}

export default CookieBanner;